import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Eye, EyeSlash, ArrowLeft, LockKey } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 6) { toast.error("Şifre en az 6 karakter olmalı"); return; }
    if (pwd !== pwd2) { toast.error("Şifreler eşleşmiyor"); return; }
    if (!token) { toast.error("Geçersiz bağlantı"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      toast.success("Şifren güncellendi. Yeni şifrenle giriş yap.");
      nav("/login");
    } catch (err) {
      toast.error(errMsg(err, "Şifre güncellenemedi"));
    } finally { setLoading(false); }
  };

  return (
    <div className="app-shell w-full max-w-md mx-auto min-h-[100dvh] px-6 py-10 flex flex-col">
      <Link to="/login" className="mb-6 inline-flex items-center gap-2 text-brand-ink2 font-nunito font-semibold text-sm" data-testid="reset-back-login">
        <ArrowLeft size={18} /> Girişe dön
      </Link>
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 rounded-2xl bg-brand-primary flex items-center justify-center">
          <LockKey size={24} weight="duotone" color="#1D3557" />
        </div>
        <div>
          <h1 className="font-outfit font-extrabold text-2xl text-brand-ink">Yeni şifre belirle</h1>
          <p className="font-nunito text-brand-ink2 text-sm">En az 6 karakter olsun.</p>
        </div>
      </div>

      <form onSubmit={submit} className="flex flex-col gap-4 mt-2">
        <div>
          <label className="font-nunito text-sm font-semibold text-brand-ink2 block mb-1.5">Yeni şifre</label>
          <div className="relative">
            <input
              data-testid="reset-password-input"
              type={show ? "text" : "password"}
              required minLength={6}
              value={pwd}
              onChange={(e) => setPwd(e.target.value)}
              className="w-full bg-white border border-black/10 rounded-2xl px-4 py-3.5 pr-12 font-nunito text-brand-ink focus:outline-none focus:ring-2 focus:ring-brand-primary"
            />
            <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 p-2 text-brand-ink2">
              {show ? <EyeSlash size={20} /> : <Eye size={20} />}
            </button>
          </div>
        </div>
        <div>
          <label className="font-nunito text-sm font-semibold text-brand-ink2 block mb-1.5">Şifre tekrar</label>
          <input
            data-testid="reset-password2-input"
            type={show ? "text" : "password"}
            required minLength={6}
            value={pwd2}
            onChange={(e) => setPwd2(e.target.value)}
            className="w-full bg-white border border-black/10 rounded-2xl px-4 py-3.5 font-nunito text-brand-ink focus:outline-none focus:ring-2 focus:ring-brand-primary"
          />
        </div>
        <button
          data-testid="reset-submit-button"
          type="submit"
          disabled={loading}
          className="mt-2 w-full bg-brand-primary text-brand-ink font-outfit font-bold text-lg py-4 rounded-full shadow-[0_4px_18px_rgba(255,183,3,0.45)] disabled:opacity-50"
        >{loading ? "Kaydediliyor..." : "Şifreyi güncelle"}</button>
      </form>
    </div>
  );
}
